import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

import Adminnavbar from "../Adminnavbar";

export default function CandidateView() {
    const { id } = useParams();
    const [loader, setLoader] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [application, setApplication] = useState({
        resume: null
    });


    useEffect(() => {
        const getApplicationData = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_BASE_URL}/application/${id}`
                );

                if (res.status === 200) {
                    setApplication(res.data.data);
                    setPdfPreviewUrl(
                        `${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/application_resume/${res.data.data.resume}`
                    );
                } else {
                    setApplication([]);
                }
            } catch (err) {
                console.log(err);
                setLoader(true);
            }
        };

        getApplicationData();
    }, [id]);


    return (
        <>
            <Adminnavbar />
            {loader || (
                <div className="page-wrapper">
                    <div className="content">
                        <form>
                            <div className="row">
                                <nav
                                    aria-label="breadcrumb"
                                    style={{ "--bs-breadcrumb-divider": "none" }}
                                >
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admindashbord">Dashboard </Link> /
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/candidate-inquiry-list">Candidate Inquiry </Link> /
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            View Candidate Inquiry
                                        </li>
                                    </ol>
                                </nav>

                                <div className="col-lg-12 col-sm-12">
                                    <div className="content-page-header">
                                        <h5>View Candidate Inquiry</h5>
                                    </div>

                                    <div className="row">
                                        {/* Title */}
                                        <div className="col-lg-2">
                                            <div className="form-group">
                                                <label>Application Date</label>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control"
                                                    value={application?.created_at?.split("T")[0] || "-"}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    value={application.name || "-"}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input
                                                    type="text"
                                                    name="email"
                                                    className="form-control"
                                                    value={application.email || "-"}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                            <div className="form-group">
                                                <label>Phone</label>
                                                <input
                                                    type="text"
                                                    name="phone"
                                                    className="form-control"
                                                    value={application.phone || "-"}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        {pdfPreviewUrl && (
                                            <div style={{ marginTop: "20px" }}>
                                                <embed
                                                    src={pdfPreviewUrl} // use the stored URL
                                                    type="application/pdf"
                                                    width="100%"
                                                    height="500px"
                                                />
                                            </div>
                                        )}

                                        {/* Buttons */}
                                        <div className="col-lg-12 mt-4">
                                            <div className="btn-path">
                                                <Link to={"/candidate-inquiry-list"} className="btn btn-cancel me-3">
                                                    Back
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
